import moment from 'moment';
class elements{
  constructor( segmId,
    segmento,
    elemId,
    elemento,
    cDesde,
    cHasta,
    conceptoId,
    concepto,
    laboral,
    aplNoFeriados,
    aplFeriados,
    resto) {
    this.segmId = segmId;
    this.segmento = segmento;
    this.elemId = elemId;
    this.elemento = elemento;
    this.cDesde = moment.utc(cDesde).format('DD-MM-YYYY');
    this.cHasta = moment.utc(cHasta).format('DD-MM-YYYY');
    this.conceptoId = conceptoId;
    this.concepto = concepto;
    this.laboral = laboral === true ? '✔️' : "";
    this.aplNoFeriados = aplNoFeriados === true ? '✔️' : "";
    this.aplFeriados = aplFeriados === true ? '✔️' : "";
    this.resto = resto === true ? '✔️' : "";
  }

  static fromJson({
    segmId,
    segmento,
    elemId,
    elemento,
    cDesde,
    cHasta,
    conceptoId,
    concepto,
    laboral,
    aplNoFeriados,
    aplFeriados,
    resto
  }) {
    return new elements(
        segmId,
        segmento,
        elemId,
        elemento,
        cDesde,
        cHasta,
        conceptoId,
        concepto,
        laboral,
        aplNoFeriados,
        aplFeriados,
        resto
    );
  }
}

export default elements;

  